<template>
  <section class="cityface">
    <div id="canvas"></div>
    <div class="cityface__loader" v-if="$store.state.route.path === '/copenhagen'"></div>
    <div class="cityface__sticker" v-else></div>
  </section>
</template>

<script>
import Faces from '@/scripts/faces';

require('intersection-observer');

export default {
  name: 'cityFace',

  data() {
    return {
      entered: false,
    };
  },

  mounted() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (this.entered) this.faces.stop();
      if (entries[0].intersectionRatio <= 0) return;
      if (!this.entered) {
        this.init();
        this.entered = true;
      } else {
        this.faces.play();
      }
    });

    this.intersectionObserver.observe(this.$el);
  },

  methods: {
    init() {
      const faceUrl = this.$store.state.dataPageCities.find(
        page => page.id === this.$store.state.route.params.city).data.cityface.url;
      this.faces = new Faces({
        cols: 4,
        elements: 12,
        urlImg: `${faceUrl}.jpg`,
        callback: this.setScale,
        perspective: 1600,
        facesIteration: 2,
        sceneScale: 0.45,
        mobileSceneScale: 0.6,
      });
    },

    setScale() {
      const el = this.faces.ctx;

      el.style.transform = 'scale(1)';
    },
  },

  beforeDestroy() {
    if (this.entered) {
      this.faces.destroy();
      this.intersectionObserver.unobserve(this.$el);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';


:global {
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}

.cityface {
  position: relative;
  width: 100%;
  height: 160vh;
  max-height: 1200px;
  margin: 0;

  @media only screen 
  and (device-width : 375px) 
  and (device-height : 812px) 
  and (-webkit-device-pixel-ratio : 3) {
    max-height: 960px;
  }


  z-index: -1;

  @include mq(md) {
    margin: 40px 0;
    max-height: none;
  }

  background-color: $color-black;

  overflow: hidden;

  #canvas {
    position: absolute;
    width: 100%;
    height: 100%;

    pointer-events: none;
  }

  &__sticker {
    position: absolute;
    bottom: 40vh;
    right: 25%;
    width: 100px;
    height: 100px;

    background-image: url('/static/vector/sticker.svg');
    background-size: 80%;
    background-position: center center;
    background-repeat: no-repeat;

    animation: rotation 5s linear infinite;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120px;
    height: 120px;

    margin-top: -60px;
    margin-left: -60px;

    background-image: url('/static/vector/loader.svg');
    background-size: 80%;
    background-position: center center;
    background-repeat: no-repeat;

    animation: rotation 10s linear infinite;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CityFace.vue